const currentYear = new Date().getFullYear();
const yearsArray = Array.from( {length: 10}, (v, i) => ({id: i+1, title: currentYear-i}) );

export const getYearList = () => yearsArray;





// export const getYearList = ()=>([
//   {id: 1, title: "2023"},
//   {id: 2, title: "2022"},
//   {id: 3, title: "2021"},
//   {id: 4, title: "2020"},
//   {id: 5, title: "2019"},
//   {id: 6, title: "2018"},
//   {id: 7, title: "2017"},
//   {id: 8, title: "2016"},
//   {id: 9, title: "2015"},
//   {id: 10, title: "2014"},
// ])